import Cookies from 'universal-cookie';
import {DOMAINS} from '../constants/DomainUrlConstants';

export const COOKIE_KEYS = {
    SPOT_COOKIE_POLICY: "spot_cookie_policy",
    DESKTOP_FALLBACK: "spot_desktop_fallback",
};
const cookies = new Cookies();


export const setCookie = (key, value) => {
    cookies.set(key, value, getOptions());
};

export const getCookieValue = (key) => {
    return cookies.get(key);
};

const getOptions = () => {
    if (window.location.hostname.includes(DOMAINS.CP.url)) {
        return {
            path: '/',
            domain: DOMAINS.CP.url
        }
    }

    if (window.location.hostname.includes(DOMAINS.ABC.url)) {
        return {
            path: '/',
            domain: DOMAINS.ABC.url
        }
    }


    if (window.location.hostname.includes(DOMAINS.VCP.url)) {
        return {
            path: '/',
            domain: DOMAINS.VCP.url
        }
    }


    return {
        path: '/'
    };
};
